import TrackInfo from './TrackInfo';

export default TrackInfo;
